import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloClient, ApolloProvider, createNetworkInterface, IntrospectionFragmentMatcher } from 'react-apollo';
import introspectionQueryResultData from './fragmentTypes.json';
import './index.css';
import './custom_icons.css';
import App from './components/app/app';
import registerServiceWorker from './registerServiceWorker';

const networkInterface = createNetworkInterface({
  uri: '/api/graphql'
});

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

networkInterface.use([{
  applyMiddleware(req, next) {
    if (!req.options.headers) {
      req.options.headers = {};
    }

    const token = localStorage.getItem('authenticationToken');
    if (token) {
      req.options.headers.Authentication = token;
    }

    next();
  }
}]);

const client = new ApolloClient({ networkInterface, fragmentMatcher });

ReactDOM.render((
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>
  ), document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js